import { person1, person2, person3, person4, person5 } from "../assets/image";
import { MEMBER } from "../type";

export const TeamMember: MEMBER[] = [
  { avatar: person2, pos: "AI Developer", name: "Hanna Camridge" },
  { avatar: person4, pos: "Founder", name: "Priven Reddy" },
  { avatar: person3, pos: "Senior Developer", name: "Anele Ndongeni" },
  { avatar: person5, pos: "COO", name: "Alessia Bestana" },
  { avatar: person1, pos: "CTO", name: "Hamza Badsha" },
];
